




import { Vue, Component, Prop } from 'vue-property-decorator'

import VueI18n from 'vue-i18n'
import VueRouter from 'vue-router'

import { BaseTabs, ChangeEvent } from '@revas/reef'

import CoreStoreModule from '@revas/kadra-library/src/revas/vue/vuex/CoreStoreModule'

@Component({
  components: {
    BaseTabs
  }
})
export default class AppNavigationTabs extends Vue {
  @Prop() readonly routeName!: string
  @Prop() readonly i18n!: VueI18n
  @Prop() readonly router!: VueRouter
  @Prop() readonly type!: string
  @Prop() readonly coreStoreModule!: CoreStoreModule

  private humansNavItems = [
    {
      key: 'humans.RESOURCE_COLLECTION.$NAME',
      value: this.i18n.t('humans.active_resources')
    },
    {
      key: 'humans.AVAILABILITY_COLLECTION.$NAME',
      value: this.i18n.t('humans.allocations')
    },
    {
      key: 'operations',
      value: this.i18n.t('humans.operations')
    },
    {
      key: 'holidays',
      value: this.i18n.t('humans.holidays')
    },
    {
      key: 'exportpayrolldata',
      value: this.i18n.t('humans.export_payroll_data')
    }
  ]

  onTabChange ($event: ChangeEvent<string>) {
    if ($event.value === 'holidays') {
      const url = `https://leaves.eu1.revas.app/organizations/${this.coreStoreModule.activeUserOrganization?.id}/holidays`
      window.open(url, '_blank')
      return
    }
    if ($event.value === 'exportpayrolldata') {
      const url = `https://leaves.eu1.revas.app/organizations/${this.coreStoreModule.activeUserOrganization?.id}/operations/exportpayrolldata`
      window.open(url, '_blank')
      return
    }
    if ($event.value !== null && $event.value !== this.routeName) {
      this.router.push({
        name: $event.value
      })
    }
  }
}
